// BC regions — derived hubs for regional SEO landing pages.
// Each region aggregates its cities and highlights industry focus.

import { CITIES } from "./cities";

export const REGIONS = [
  {
    slug: "metro-vancouver",
    name: "Metro Vancouver",
    image: "https://images.unsplash.com/photo-1559511260-66a654ae982a",
    tagline: "Downtown towers, industrial waterfront, and 20 municipalities under one dispatch.",
    overview:
      "Metro Vancouver is the economic engine of British Columbia — a Pacific Rim port, Class-A office core, dense residential high-rise, and heavy industrial from Delta to Maple Ridge. Our Metro fleet runs 24/7 mobile patrol, downtown concierge, Port of Vancouver marine ops, and event coverage for BC Place, Rogers Arena, and PNE.",
    industries: [
      "Class-A office towers",
      "Residential high-rise & stratas",
      "Port of Vancouver terminals",
      "YVR-adjacent logistics",
      "Retail plazas & malls",
      "Construction & renovation",
    ],
    keywords: [
      "security services Metro Vancouver",
      "security guards Metro Vancouver",
      "mobile patrol Lower Mainland",
      "Lower Mainland security company",
      "downtown Vancouver concierge security",
      "industrial security Metro Vancouver",
    ],
  },
  {
    slug: "fraser-valley",
    name: "Fraser Valley",
    image: "https://images.unsplash.com/photo-1541516160071-4bb0c5af65ba",
    tagline: "Agriculture, industrial corridors, and cannabis LPs from Abbotsford to Hope.",
    overview:
      "The Fraser Valley blends farmland, aviation, industrial parks, and one of Canada's largest cannabis cultivation belts. Our teams cover greenhouses, LPs, agricultural properties, industrial warehouses along the Highway 1 corridor, and growing residential communities in Abbotsford, Chilliwack, Mission, and Langley.",
    industries: [
      "Cannabis licensed producers",
      "Agricultural sites",
      "Airport support",
      "Warehouse & distribution",
      "New residential developments",
    ],
    keywords: [
      "Fraser Valley security services",
      "security guards Abbotsford Chilliwack",
      "cannabis security Fraser Valley",
      "farm security BC",
      "Highway 1 industrial security",
    ],
  },
  {
    slug: "vancouver-island",
    name: "Vancouver Island",
    image: "https://images.unsplash.com/photo-1601050440068-e78a3d64ef97",
    tagline: "Victoria to Campbell River — capital security, marina patrols, and CFB-adjacent coverage.",
    overview:
      "Vancouver Island stretches from the legislature and Inner Harbour in Victoria to remote fishing communities in the North Island. Our Island teams handle government buildings, cruise berths, ferry terminals, marinas, CFB Comox-adjacent facilities, and downtown retail across Nanaimo, Duncan, Parksville, and beyond.",
    industries: [
      "Provincial government",
      "Marinas & harbour terminals",
      "Cruise & ferry",
      "Retail & hospitality",
      "Rural residential",
    ],
    keywords: [
      "Vancouver Island security services",
      "Victoria BC security guards",
      "island security company BC",
      "marina security Vancouver Island",
      "ferry terminal security BC",
    ],
  },
  {
    slug: "okanagan",
    name: "Okanagan",
    image: "https://images.unsplash.com/photo-1601370552761-3f176a1e0e7c",
    tagline: "Wineries, waterfront festivals, and rapid construction from Vernon to Penticton.",
    overview:
      "The Okanagan Valley is Canada's wine country plus a fast-growing tech and residential hub. We cover wineries, orchards, Kelowna and Penticton festivals (Peach Fest, Ironman, Kelowna Fest), Silver Star and Big White ski resorts, and construction along Highway 97.",
    industries: [
      "Wineries & orchards",
      "Festival & event security",
      "Ski resort support",
      "Construction",
      "Tourism & hospitality",
    ],
    keywords: [
      "Okanagan security services",
      "winery security Okanagan",
      "Kelowna security company",
      "event security Okanagan Valley",
      "Silver Star Big White security",
    ],
  },
  {
    slug: "kootenays",
    name: "Kootenays",
    image: "https://images.unsplash.com/photo-1508739773434-c26b3d09e071",
    tagline: "Ski resorts, coal mines, and heritage downtowns across East and West Kootenays.",
    overview:
      "The Kootenays cover East (Cranbrook, Fernie, Kimberley) and West (Nelson, Trail, Castlegar, Rossland) with a mix of coal mining (Elk Valley), Teck smelter operations in Trail, resort tourism at Fernie Alpine and Kimberley Alpine, and cannabis-friendly retail in Nelson.",
    industries: [
      "Coal mining & aggregate",
      "Smelter & industrial",
      "Ski resorts",
      "Cannabis retail",
      "Heritage downtown retail",
    ],
    keywords: [
      "Kootenay security services",
      "coal mine security Fernie",
      "Trail smelter security",
      "Nelson BC security",
      "ski resort security Kootenays",
    ],
  },
  {
    slug: "peace-region",
    name: "Peace Region",
    image: "https://images.unsplash.com/photo-1628487749130-2d41acb1802a",
    tagline: "Oil & gas, Site C construction, and Mile 0 of the Alaska Highway.",
    overview:
      "The Peace Region centres on Fort St. John and Dawson Creek — energy sector camps, Site C hydroelectric construction, oilfield services, agriculture, and cross-border commerce. Our teams staff camp gates, run mobile patrols across remote lease sites, and coordinate with LNG Canada logistics.",
    industries: [
      "Oil & gas facilities",
      "Site C hydroelectric",
      "Remote camps",
      "Agricultural properties",
      "Highway commercial",
    ],
    keywords: [
      "Peace Region security services",
      "oilfield security BC",
      "Site C security Fort St John",
      "Dawson Creek security",
      "remote camp security BC",
    ],
  },
  {
    slug: "northern-bc",
    name: "Northern BC",
    image: "https://images.unsplash.com/photo-1518878170907-ca4de6a4d3a1",
    tagline: "Prince George, LNG Canada, Kitimat aluminum — resource security at scale.",
    overview:
      "Northern BC covers Prince George, Terrace, and Kitimat — resource industry hubs supporting LNG Canada, Rio Tinto aluminum smelting, forestry, and northern rail and port logistics. We staff industrial gatehouses, remote patrols, and camp accommodations across the region.",
    industries: [
      "LNG Canada support",
      "Aluminum smelter (Kitimat)",
      "Forestry mills",
      "UNBC campus",
      "Airport & rail",
    ],
    keywords: [
      "Northern BC security",
      "LNG Canada security Kitimat",
      "Prince George security guards",
      "Terrace BC security",
      "resource industry security BC",
    ],
  },
  {
    slug: "sea-to-sky",
    name: "Sea-to-Sky",
    image: "https://images.unsplash.com/photo-1449965408869-eaa3f722e40d",
    tagline: "Squamish LNG, Whistler resort, and adventure tourism between them.",
    overview:
      "The Sea-to-Sky corridor from Horseshoe Bay through Squamish and Britannia Beach up to Whistler and Pemberton — Woodfibre LNG-adjacent industrial, luxury resort concierge, event security for Whistler festivals, and outdoor tourism operators.",
    industries: [
      "LNG facility support",
      "Luxury resort concierge",
      "Festival & event",
      "Adventure tourism",
      "Highway commercial",
    ],
    keywords: [
      "Sea-to-Sky security services",
      "Whistler resort security",
      "Squamish security guards",
      "Woodfibre LNG security",
      "adventure tourism security BC",
    ],
  },
  {
    slug: "cariboo",
    name: "Cariboo",
    image: "https://images.unsplash.com/photo-1508739773434-c26b3d09e071",
    tagline: "Ranchland, forestry mills, and rodeo events from Williams Lake to Quesnel.",
    overview:
      "The Cariboo runs along Highway 97 north — ranchland, forestry, and mining service centres. Williams Lake hosts one of Canada's largest rodeos every summer, requiring layered event security teams from our regional dispatch.",
    industries: [
      "Forestry mills",
      "Mining service",
      "Ranchland & agricultural",
      "Rodeo & event",
      "Highway commercial",
    ],
    keywords: [
      "Cariboo security services",
      "Williams Lake security",
      "Quesnel BC security",
      "rodeo event security Cariboo",
      "forestry security BC",
    ],
  },
];

export function getRegionBySlug(slug) {
  return REGIONS.find((r) => r.slug === slug);
}

export function getCitiesForRegion(regionName) {
  return CITIES.filter((c) => c.region === regionName);
}
